export type WindowType = 'traversing_drape' | 'side_panel' | 'roman_shade' | 'roller_shade'
  | 'roman_valance' | 'pleated_valance' | 'tailored_valance' | 'shirred_valance' | 'balloon_shade' | 'austrian_shade';

export type SoftGoodsType = 'pillow' | 'sham' | 'bolster_pillow' | 'cushion'
  | 'dustskirt' | 'box_spring_cover' | 'duvet' | 'coverlet'
  | 'tablecloth_round' | 'tablecloth_rectangle';

export type FurnitureType = 'furniture';

export type ItemTypeEnum = WindowType | SoftGoodsType | FurnitureType;

export const WINDOW_TYPES: { value: WindowType; label: string }[] = [
  { value: 'traversing_drape',  label: 'Traversing Drape' },
  { value: 'side_panel',        label: 'Side Panel' },
  { value: 'roman_shade',       label: 'Roman Shade' },
  { value: 'roller_shade',      label: 'Roller Shade' },
  { value: 'roman_valance',     label: 'Roman Valance' },
  { value: 'pleated_valance',   label: 'Pleated Valance' },
  { value: 'tailored_valance',  label: 'Tailored Valance' },
  { value: 'shirred_valance',   label: 'Shirred Valance' },
  { value: 'balloon_shade',     label: 'Balloon Shade' },
  { value: 'austrian_shade',    label: 'Austrian Shade' },
];

export const SOFT_GOODS_TYPES: { value: SoftGoodsType; label: string }[] = [
  { value: 'pillow',              label: 'Pillow' },
  { value: 'sham',                label: 'Sham' },
  { value: 'bolster_pillow',      label: 'Bolster Pillow' },
  { value: 'cushion',             label: 'Cushion' },
  { value: 'dustskirt',           label: 'Dustskirt' },
  { value: 'box_spring_cover',    label: 'Box Spring Cover' },
  { value: 'duvet',                label: 'Duvet' },
  { value: 'coverlet',            label: 'Coverlet' },
  { value: 'tablecloth_round',    label: 'Tablecloth (Round)' },
  { value: 'tablecloth_rectangle', label: 'Tablecloth (Rectangle)' },
];

// No SOP exists yet for furniture pricing — added purely to test the
// quote → work order flow end to end. See calcFurniture() in
// server/src/plugins/sopCalculations.ts.
export const FURNITURE_TYPES: { value: FurnitureType; label: string }[] = [
  { value: 'furniture', label: 'Furniture (Sofa/Loveseat — best guess pricing)' },
];

export const ALL_TYPES = [...WINDOW_TYPES, ...SOFT_GOODS_TYPES, ...FURNITURE_TYPES];

// Contract every per-product-type form component implements. Each type owns its
// own internal question set/state; the parent only knows how to ask it for the
// final values (or null if the component's own validation failed).
export interface ObjectTypeFormHandle {
  getValues: () => Record<string, any> | null;
}

export interface ObjectTypeFormProps {
  disabled: boolean;
  // When set, the form should hydrate its fields from these values instead of
  // starting blank — used by the "Go back" flow to let a user re-edit the
  // inputs behind an already-saved object and recompute it.
  initialValues?: Record<string, any> | null;
}
